import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { GoalType } from '@flugwettrennen/shared';
import { api, type LeaderboardEntry } from '../api';
import { Leaderboard } from '../components/Leaderboard';
import { goalLabel } from '../lib/goals';

export function ChallengePage() {
  const { code = '' } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState<
    { code: string; goalTypes: GoalType[]; name: string; entries: LeaderboardEntry[] } | null | 'error'
  >(null);

  useEffect(() => {
    api.rounds
      .challenge(code)
      .then(setData)
      .catch(() => setData('error'));
  }, [code]);

  if (data === null) return <div className="container page"><div className="spinner" /></div>;
  if (data === 'error') return <div className="container page"><div className="notice notice-error">{t('challenge.notFound')}</div></div>;

  return (
    <div className="container page stack">
      <div>
        <div className="eyebrow">{goalLabel(t, data.goalTypes)}</div>
        <h1 style={{ marginBottom: 2 }}>{t('challenge.leaderboard')}</h1>
        <p className="muted mono">{data.name} · {t('challenge.code')}: {data.code}</p>
      </div>

      <div className="card">
        <Leaderboard entries={data.entries} />
      </div>

      <div>
        <Link className="btn" to="/">{t('result.backToDirectory')}</Link>
      </div>
    </div>
  );
}
